import type { SelectorObject } from '../types';

export const perUnitUsageChargeFormSelectors = {
  nameInput: 'per-unit-usage-charge-form-name-input',
  priceInput: 'per-unit-usage-charge-form-price-input',
} satisfies SelectorObject<'per-unit-usage-charge-form-'>;